exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "p {\n  margin-bottom: 0;\n}\n", ""]);

